import { DOCUMENT } from '@angular/common';
import { Injectable, signal, effect, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly document = inject(DOCUMENT);
  private readonly prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
  private readonly STORAGE_KEY = 'app-theme-preference';
  private readonly classList = this.document.documentElement.classList;

  readonly isDark = signal<boolean>(this.resolveInitial());

  constructor() {
    this.prefersDark.addEventListener('change', this.onSystemThemeChange);
    effect(() => {
      const dark = this.isDark();
      this.applyTheme(dark);
      this.persist(dark);
    });
  }

  toggle(): void {
    this.isDark.update((v) => !v);
  }

  init(): void {
    this.applyTheme(this.isDark());
  }

  private onSystemThemeChange = (): void => {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (!stored) {
      this.isDark.set(this.prefersDark.matches);
    }
  };

  private resolveInitial(): boolean {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (stored === 'light') return false;
    if (stored === 'dark') return true;
    return this.prefersDark.matches;
  }

  private applyTheme(dark: boolean): void {
    this.classList.remove('theme-dark', 'theme-light');
    this.classList.add(dark ? 'theme-dark' : 'theme-light');
  }

  private persist(dark: boolean): void {
    localStorage.setItem(this.STORAGE_KEY, dark ? 'dark' : 'light');
  }
}
